import {Api} from '../../../Api.js'

const RESOURCE = 'checkin'

export default {
    resource: RESOURCE,
    prefix: 'checkin/',
    query(query) {
        return Api().get(this.prefix + this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.prefix + this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.prefix + this.resource, data)
    },
    update(id, data) {
        return Api().put(this.prefix + this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.prefix + this.resource + '/' + id)
    }
}


// WEBPACK FOOTER //
// ./src/modules/checkin/reservation/ReservationService.js